'use strict';

angular.module('app.manualPosts', [])
    .controller('manualPostsCtrl', ['$scope', '$modal', 'adminService', 'manualPostsService',
        function ($scope, $modal, adminService, manualPostsService) {
            $scope.isImageLoading = false;
            $scope.isVideoLoading = false;

            $scope.imageUrl = null;
            $scope.videoUrl = null;

            $scope.mediaWidth = null;
            $scope.mediaHeight = null;
            $scope.imageWidth = null;
            $scope.imageHeight = null;

            $scope.today = function() {
                $scope.dt_publishDate = moment().format('DD-MM-YYYY');
            };
            $scope.today();

            $scope.clear = function () {
                $scope.dt_publishDate = today();
                $scope.postURL = '';
                $scope.title = '';
                $scope.content = '';
                $scope.influencerId = '';
                $scope.channelId = '';
                $scope.postType = 'ig_post';
                $scope.isVideo = false;
                $scope.isStory = false;
                $scope.replies = 0;
                $scope.comments = 0;
                $scope.playlists = 0;
                $scope.dislikes = 0;
                $scope.likes = 0;
                $scope.shares = 0;
                $scope.views = 0;
                $scope.plays = 0;
                $scope.impact = 0;
                $scope.engagement = 0;
                $scope.reach = 0;
                $scope.impression = 0;
                $scope.mentions = '';
                $scope.isImageLoading = false;
                $scope.isVideoLoading = false;
                $scope.imageUrl = null;
                $scope.videoUrl = null;
                $scope.mediaWidth = null;
                $scope.mediaHeight = null;
                $scope.imageHeight = null;
                $scope.imageWidth = null;
            };

            // Disable weekend selection
            $scope.disabled = function(date, mode) {
                return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
            };

            $scope.toggleMin = function() {
                $scope.minDate = $scope.minDate ? null : new Date();
            };
            $scope.toggleMin();

            $scope.openPublishDate = function($event,option) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.openedPublishDate = true;
            };
            $scope.dateOptions = {
                formatYear: 'yy',
                startingDay: 1
            };

            $scope.formats = ['dd-MM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'DD-MM-YYYY', 'shortDate'];
            $scope.format = $scope.formats[0];

            $scope.preLoaded = false;
            $scope.currentPage = 1;
            $scope.pageSize = 25;
            $scope.hasValue = null;

            //server-side
            $scope.preLoadData = function(hasValue, flag){
                if(hasValue == null){
                    var params = {
                        pageNo: $scope.currentPage
                    }

                    $scope.sendHttpPOST(params);
                }
                $scope.preLoaded = true;
            }

            $scope.sendHttpPOST = function(params){
                // manualPostsService.getManualPosts(params, true)
                //     .then(function(response) {
                //         $scope.posts = response.data;
                //         $scope.number = response.totalRow;
                //         $scope.pagination();
                //     }, function(response){
                //         var errorModalInstance = $modal.open({
                //             scope: $scope,
                //             templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                //             windowClass: 'modal-dialog-mention-error'
                //         });
                //         $scope.errorModalInstance = errorModalInstance;
                //         $scope.errorMessage = response.message;
                //     })
            }

            if(!$scope.preLoaded){
                $scope.preLoadData($scope.hasValue);
            }

            $scope.pagination = function(){
                $scope.pages = adminService.pagination($scope.number, $scope.pageSize);
            };

            $scope.updatePage = function(val,flag){
                $scope.currentPage = val;
                var params = {
                    pageNo: $scope.currentPage
               } 

               $scope.sendHttpPOST(params);
            }

            $scope.fetchChannels = function(influencerId) {
                if (!influencerId) return;
                manualPostsService.getInfluencerChannel(influencerId)
                    .then(function(response) {
                        $scope.channels = response.data.data.map(function(c) {
                            return c.handle + ' - ' + c.platform.name;
                        });
                    }, function(error) {
                        alert('Error fetching channels: ' + error);
                    });
            };
    
            $scope.$watch('influencerId', function(newVal) {
                if (newVal) {
                    $scope.fetchChannels(newVal);
                }
            });

            if ($scope.imageFile) {
                uploadFile($scope.imageFile, 'image').then(function(result) {
                  $scope.imageUrl = result.url;
                  $scope.imageWidth = result.width;
                  $scope.imageHeight = result.height;
                  console.log('Image uploaded:', result.url, result.width, result.height);
                }).catch(function(error) { alert('Error uploading image: ' + error); });
              }
              
              if ($scope.isVideo && $scope.videoFile) {
                uploadFile($scope.videoFile, 'video').then(function(result) {
                  $scope.videoUrl = result.url;
                  $scope.videoWidth = result.width;
                  $scope.videoHeight = result.height;
                  console.log('Video uploaded:', result.url, result.width, result.height);
                }).catch(function(error) { alert('Error uploading video: ' + error); });
              }

            function uploadFile(file, type) {
                return new Promise(function(resolve, reject) {
                  if (type === 'image') $scope.isImageLoading = true;
                  else $scope.isVideoLoading = true;
              
                  var presignedUrl;
              
                  manualPostsService.getPresignedUrl({ fileName: file.name })
                    .then(function(response) {
                      presignedUrl = response.data.presignedUrl;
                      return manualPostsService.uploadFile(presignedUrl, file);
                    })
                    .then(function() {
                      var fileUrl = presignedUrl.split('?')[0];
              
                      if (type === 'image') {
                        var img = new Image();
                        img.src = fileUrl;
                        img.onload = function() {
                          $scope.isImageLoading = false;
                          resolve({
                            url: fileUrl,
                            width: img.width,
                            height: img.height
                          });
                        };
                        img.onerror = reject;
                      } else if (type === 'video') {
                        var video = document.createElement('video');
                        video.src = fileUrl;
                        video.onloadedmetadata = function() {
                          $scope.isVideoLoading = false;
                          resolve({
                            url: fileUrl,
                            width: video.videoWidth,
                            height: video.videoHeight
                          });
                        };
                        video.onerror = reject;
                      } else {
                        reject(new Error('Unsupported type'));
                      }
                    })
                    .catch(function(error) {
                      $scope.isImageLoading = false;
                      $scope.isVideoLoading = false;
                      reject(error);
                    });
                });
              }

            $scope.addManualPost = function () {
                if (!$scope.validateForm()) return

                var day = moment.duration(moment() - $scope.dt_publishDate).days();
                $scope.dt_publishDate = moment().subtract(day, 'days').format('YYYY-MM-DD');
                var params = {
                    fullUrl: $scope.postURL,
                    publishedDate: $scope.dt_publishDate,
                    title: $scope.title,
                    content: $scope.content,
                    influencerId: $scope.influencerId,
                    channelId: $scope.channelId,
                    postType: $scope.postType,
                    isVideo: $scope.isVideo,
                    isStory: $scope.isStory,
                    replies: parseNumber($scope.replies),
                    comments: parseNumber($scope.comments),
                    playlists: parseNumber($scope.playlists),
                    dislikes: parseNumber($scope.dislikes),
                    likes: parseNumber($scope.likes),
                    shares: parseNumber($scope.shares),
                    views: parseNumber($scope.views),
                    plays: parseNumber($scope.plays),
                    impact: parseNumber($scope.impact),
                    engagement: parseNumber($scope.engagement),
                    reach: parseNumber($scope.reach),
                    impression: parseNumber($scope.impression),
                    imageUrl: $scope.imageUrl,
                    videoUrl: $scope.videoUrl,
                    mediaHeight: $scope.mediaHeight,
                    mediaWidth: $scope.mediaWidth,
                    imageHeight: $scope.imageHeight,
                    imageWidth: $scope.imageWidth,
                    mentions: $scope.mentions ? $scope.mentions.split(',').map(function(mention) { return mention.trim(); }).join(',') : ''
                }

                manualPostsService.addManualPost(params, true) 
                    .then(function(response) {
                        location.reload('admin/manualPosts');
                        $scope.clear();
                    }, function(response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }
            
            $scope.validateForm = function() {
                var postUrl = $scope.postURL;
                var title = $scope.title ? $scope.title.trim() : '';
                var publishDate = $scope.dt_publishDate;
                var influencerId = $scope.influencerId;
                var channelId = $scope.channelId;

                var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name and extension
                    '(\\/[-a-z\\d%@_.~+&:]*)*'+ // path
                    '(\\?[;&a-z\\d%@_.,~+&:=-]*)?$','i'); // query string

                if (!urlPattern.test(postUrl)) {
                    alert('Please enter a valid URL.');
                    return false;
                }

                if (!title) {
                  alert('Title is required.');
                  return false;
                }
        
                if (!validateDate(publishDate)) {
                  alert('Date must be in format dd-MM-yyyy.');
                  return false;
                }
        
                if (!influencerId) {
                  alert('Influencer ID is required.');
                  return false;
                }

                if (!channelId) {
                    alert('Channel is required.');
                    return false;
                }

                if (!$scope.imageUrl) {
                    alert('Image is required.');
                    return false;
                }

                if ($scope.isVideo && !$scope.videoUrl) {
                    alert('Video is required.');
                    return false;
                }
        
                // Parse number fields
                ['replies', 'comments', 'likes', 'shares', 'views', 'plays', 'impact', 'engagement', 'reach', 'impression'].forEach(function(field) {
                    var nb =  parseNumber($scope[field]);
                    if (isNaN(nb)) {
                        alert('Please enter a valid number for ' + $scope[field]);
                        return false;
                    }
                    $scope[field] = parseNumber($scope[field]);
                });
        
                // Process mentions
                if ($scope.mentions) {
                  $scope.mentions = $scope.mentions.split(',').map(function(mention) {
                    return mention.trim();
                  }).join(',');
                }
        
                return true;
              };
        
              function parseNumber(value) {
                if (typeof value === 'string') {
                  value = value.trim().toUpperCase();
                  if (value.endsWith('K')) {
                    return parseFloat(value) * 1000;
                  } else if (value.endsWith('M')) {
                    return parseFloat(value) * 1000000;
                  }
                }
                return parseFloat(value) || 0;
              }
        
              function validateDate(dateString) {
                var regex = /^\d{2}-\d{2}-\d{4}$/;
                return regex.test(dateString);
              }
}])